import { ADD_EXTENDED, REMOVE_EXTENDED } from 'messages'
import stickySummary from '../components/plan-summary/sticky'
import toastNotification from 'pug/toastNotification'
import store from 'utils/store/withMiddleware'
import { deepClone } from '@hc-frontend/utils'

function handleToggleExtended() {
  const state = store.getState()
  const extended = state.isExtendedPlan

  toastNotification(extended ? REMOVE_EXTENDED : ADD_EXTENDED)

  const filters = deepClone(state.filters)
  filters.policies =
    filters.policies === state.minPolicies ? state.maxPolicies : state.minPolicies
  store.update({ filters })
  stickySummary()
}

export default handleToggleExtended
